export const CALENDAR = 1;
export const MOST_PLAYED_OPTIONS = 2;
export const COUNTRIES_AND_CATEGORIES = 3;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/PickerID.js